var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { useSlate } from "slate-react";
import { css } from "@emotion/css";
import { Button, Icon } from "../BaseComponents";
import { toggleMark } from "../../plugins/helpers/toggleMark";
import ColorPalte from "./ColorPlate";
var StateButton = function (props) {
    var format = props.format, icon = props.icon, defaultState = props.defaultState;
    var _a = __read(useState(), 2), color = _a[0], setColor = _a[1];
    var _b = __read(useState(false), 2), isChange = _b[0], setIsChange = _b[1];
    useEffect(function () {
        setColor(defaultState);
    }, [defaultState]);
    var editor = useSlate();
    var changeColorHandler = function (newColor) {
        setColor(newColor);
    };
    return (_jsxs("div", __assign({ className: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        position: relative;\n      "], ["\n        position: relative;\n      "]))) }, { children: [_jsx(Button, __assign({ buttonColor: color, onMouseDown: function (event) {
                    event.preventDefault();
                    toggleMark(editor, format, color);
                } }, { children: _jsx(Icon, { children: icon }) })), _jsxs(Button, __assign({ className: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          position: absolute;\n          top: 0px;\n          right: -5px;\n          display: inline-block;\n        "], ["\n          position: absolute;\n          top: 0px;\n          right: -5px;\n          display: inline-block;\n        "]))), onMouseDown: function (event) {
                    event.preventDefault();
                    setIsChange(function (prev) { return !prev; });
                } }, { children: [_jsx(Icon, __assign({ className: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            font-size: 14px;\n            vertical-align: top;\n          "], ["\n            font-size: 14px;\n            vertical-align: top;\n          "]))) }, { children: "arrow_drop_down" })), isChange && _jsx(ColorPalte, { cb: changeColorHandler })] }))] })));
};
export default StateButton;
var templateObject_1, templateObject_2, templateObject_3;
